import { render, staticRenderFns } from "./CredStatusModal.vue?vue&type=template&id=42974384&scoped=true"
import script from "./CredStatusModal.vue?vue&type=script&lang=js"
export * from "./CredStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42974384",
  null
  
)

export default component.exports